if (typeof LayerWindow === "undefined") {
  class LayerWindow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.header-section');
      this.productTips = document.querySelectorAll('.js-product-tips');
      this.toggles = this.querySelectorAll(".js-layer-toggle");
      this.selected = this.querySelector(".js-layer-selected");
      this.layer = this.querySelector(".js-layer");
      this.inputs = this.querySelectorAll("input:not([type='search']");
      this.labels = this.querySelectorAll(".js-variant-label");
      this.selects = this.querySelectorAll("select");
      this.initEvent();
    }

    initEvent() {
      if (this.toggles) {
        this.toggles.forEach((toggle) => {
          toggle.addEventListener("click", this.toggleLayer.bind(this));
        })
      }

      if (this.inputs && !this.hasAttribute('cart-drawer')) {
        this.inputs.forEach((input) => {
          input.addEventListener("change", this.selectValue.bind(this, input));
        })
      }

      if (this.labels) {
        this.labels.forEach((label) => {
          label.addEventListener("click", this.selectLabel.bind(this, label));
        })
      }
    }

    toggleLayer() {
      if (!this.classList.contains("--no-index")) {
        this.header.classList.toggle("--open-layer");
      }
      this.layer.classList.toggle("--open");
    }

    selectValue(input) {
      if (this.selected) {
        this.selected.classList.remove("--oos");
        this.selected.classList.remove("--not-selected");
        this.selected.innerHTML = input.value;
        if (input.classList.contains("is-disabled")) {
          this.selected.classList.add("--oos");
          this.productTips.forEach((tip) => {
            tip.classList.add("hidden");
          })
        } else {
          this.productTips.forEach((tip) => {
            tip.classList.remove("hidden");
          })
        }
        this.toggleLayer();
      }
    }

    selectLabel(label) {
      const id = label.getAttribute("for");
      const input = this.querySelector(`input[id=${id}]`);
      if (input.checked) {
        const event = new Event('change');
        input.dispatchEvent(event);
      }
    }
  }

  if (!customElements.get("layer-window")) {
    customElements.define("layer-window", LayerWindow);
  }
}